import { LightMode, DarkMode } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setThemeMode } from "../../Redux/Actions/ThemeMode";

const Header = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.themeMode);

  const ThemeToggle = () => {
    dispatch(setThemeMode(!themeMode));
  };
  useEffect(() => {
    themeMode
      ? document.body.classList.add("dark")
      : document.body.classList.remove("dark");
  }, [themeMode]);
  console.log("ThemeMode:-----", themeMode);
  return (
    <div className="center h-[10vh]">
      Theme
      <IconButton onClick={ThemeToggle}>
        {themeMode ? <LightMode /> : <DarkMode />}
      </IconButton>
    </div>
  );
};

export default Header;
